import React from 'react';
import WIcon from './WIcon';

const StatCard = ({ icon, label, value, sub, variant = 'brand', dark = false }) => {
  const iconClass = dark ? '' : `stat-icon-${variant}`;
  return (
    <div className={`loysta-stat-card${dark ? ' dark' : ''}`}>
      <div className="loysta-stat-card-head">
        <span className="loysta-stat-card-label">{label}</span>
        <div className={`loysta-stat-card-icon ${iconClass}`}>
          <WIcon name={icon} size={18} />
        </div>
      </div>
      <div className="loysta-stat-card-value">{value}</div>
      {sub && <div className="loysta-stat-card-sub">{sub}</div>}
    </div>
  );
};

export default StatCard;
